<template>
    <v-dialog v-model="openMode" max-width="780px" content-class="cs-dialog" overlay-color="#0d2c6d"
        overlay-opacity="0.55" transition="dialog-bottom-transition">
        <v-card class="cs-dlg-card">

            <!-- ───────── HEADER ───────── -->
            <div class="cs-dlg-head">
                <div class="cs-dlg-head__main">
                    <div class="cs-dlg-head__icon" aria-hidden="true">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <div>
                        <span class="cs-dlg-eyebrow">פרטי לקוח</span>
                        <h2 class="cs-dlg-title">{{ formTitle }}</h2>
                    </div>
                </div>
                <button type="button" class="cs-dlg-close" @click="openMode = false" aria-label="סגור">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </div>

            <!-- ───────── BODY ───────── -->
            <v-card-text class="cs-dlg-body">
                <v-form @submit.prevent="submitHandler" ref="form">

                    <div class="cs-dlg-section">
                        <h3 class="cs-dlg-section__title">
                            <span class="cs-dlg-section__bar"></span>
                            פרטים אישיים
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.name" label="שם"
                                    :rules="[v => !!v || 'שדה חובה']" required
                                    prepend-inner-icon="mdi-account"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.family" label="משפחה"
                                    :rules="[v => !!v || 'שדה חובה']" required
                                    prepend-inner-icon="mdi-account-multiple"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.business_name" label="שם לחשבונית"
                                    :rules="[v => !!v || 'שדה חובה']" required
                                    prepend-inner-icon="mdi-file-document-outline"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.email" label="אימייל"
                                    prepend-inner-icon="mdi-email-outline"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="cs-dlg-section">
                        <h3 class="cs-dlg-section__title">
                            <span class="cs-dlg-section__bar"></span>
                            פרטי קשר
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.phone1" type="number" hide-spin-buttons
                                    label="טלפון 1" :rules="[v => !!v || 'שדה חובה']" required
                                    prepend-inner-icon="mdi-phone"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.phone2" type="number" hide-spin-buttons
                                    label="טלפון 2" prepend-inner-icon="mdi-phone-outline"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="cs-dlg-section">
                        <h3 class="cs-dlg-section__title">
                            <span class="cs-dlg-section__bar"></span>
                            כתובת
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.address" label="רחוב"
                                    prepend-inner-icon="mdi-road-variant"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="itemEdited.building" label="מספר בית"
                                    prepend-inner-icon="mdi-home-outline"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="itemEdited.postal_code" type="number"
                                    hide-spin-buttons label="מיקוד"
                                    prepend-inner-icon="mdi-mailbox-outline"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="cs-dlg-section">
                        <h3 class="cs-dlg-section__title">
                            <span class="cs-dlg-section__bar"></span>
                            אמצעי תשלום
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.last_digits" type="number"
                                    hide-spin-buttons label="4 ספרות אחרונות של אמצעי התשלום"
                                    prepend-inner-icon="mdi-credit-card-outline"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                </v-form>
            </v-card-text>

            <!-- ───────── FOOTER ───────── -->
            <div class="cs-dlg-foot">
                <v-progress-linear v-if="progressShow" indeterminate color="#0d2c6d" height="2"
                    class="cs-dlg-progress" />
                <div class="cs-dlg-foot__actions">
                    <button type="button" class="cs-dlg-btn cs-dlg-btn--ghost" @click="openMode = false"
                        :disabled="progressShow">ביטול</button>
                    <button type="button" class="cs-dlg-btn cs-dlg-btn--primary"
                        @click="formTitle === 'ערוך פרטי לקוח' ? saveEditedItem() : saveNewItem()"
                        :disabled="progressShow">
                        <svg v-if="!progressShow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5"></path>
                        </svg>
                        <span>{{ progressShow ? 'שומר...' : 'שמור שינויים' }}</span>
                    </button>
                </div>
            </div>

        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'
import Auth from '@/services/auth.service';

export default {
    props: {
        itemToEdit: Object,
        formTitle: String,
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        itemEdited: {
            _id: "",
            card_id: "",
            family: "",
            name: "",
            phone1: "",
            phone2: "",
            business_name: "",
            address: "",
            building: 0,
            postal_code: "",
            last_digits: "",
            email: "",
        },
    }),

    methods: {
        async saveNewItem() {

        },
        async saveEditedItem() {
            if (this.$refs.form.validate()) {

                const myJSON = JSON.stringify({ customer: this.itemEdited });
                this.progressShow = true;
                let token = localStorage.getItem("token");

                try {
                    let api = process.env.VUE_APP_BASE_URL + "/customers/edit_customer";
                    const res = await fetch(api, ApiServices.requestOptions("PUT", myJSON, token));
                    this.progressShow = false;
                    const jsonObject = await res.json();
                    if (res.status >= 400) {
                        this.showSnackBar("Error: " + jsonObject, "red");
                    } else if (res.status === 200) {
                        this.$emit("itemEdited", this.itemEdited, "הלקוח עודכן בהצלחה", "green");
                        this.openMode = false;
                    }
                } catch (error) {
                    this.progressShow = false;
                    this.showSnackBar("Error saved edited customer: " + error, "red");

                }

            }
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
    },
    mounted() {
        if (this.formTitle === "ערוך פרטי לקוח") {
            this.itemEdited = JSON.parse(JSON.stringify(this.itemToEdit));
        }
    },
}
</script>

<style scoped>
/* container */
.cs-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

.cs-dlg-card {
    --c-navy: #0d2c6d;
    --c-indigo: #3F51B5;
    --c-purple: #8066f0;
    --c-border-soft: #eef2f7;
    --c-text: #0f172a;
    --c-text-soft: #475569;
    --c-text-mute: #94a3b8;
    font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
    direction: rtl;
    background: #ffffff !important;
    border-radius: 20px !important;
    overflow: hidden;
}

/* ─── HEADER ─── */
.cs-dlg-head {
    position: relative;
    background:
        radial-gradient(800px 200px at 90% -40%, rgba(253, 183, 33, 0.08), transparent 60%),
        linear-gradient(135deg, #0d2c6d 0%, #142f78 55%, #1a3a8a 100%);
    color: #fff;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.cs-dlg-head__main {
    display: flex;
    align-items: center;
    gap: 14px;
}

.cs-dlg-head__icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: grid;
    place-items: center;
    color: #fff;
}

.cs-dlg-eyebrow {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 1px;
}

.cs-dlg-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: -0.01em;
    color: #fff;
}

.cs-dlg-close {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    cursor: pointer;
    display: grid;
    place-items: center;
    transition: background 0.2s, transform 0.2s;
}

.cs-dlg-close:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: rotate(90deg);
}

/* ─── BODY ─── */
.cs-dlg-body {
    padding: 24px 28px 8px !important;
    background: #fbfcfe;
    max-height: 65vh;
    overflow-y: auto;
}

.cs-dlg-section {
    margin-bottom: 18px;
    padding: 16px 18px 6px;
    background: #ffffff;
    border: 1px solid var(--c-border-soft);
    border-radius: 14px;
}

.cs-dlg-section__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--c-navy);
    margin: 0 0 14px;
}

.cs-dlg-section__bar {
    width: 3px;
    height: 16px;
    background: linear-gradient(180deg, var(--c-navy), var(--c-purple));
    border-radius: 2px;
}

::v-deep .v-text-field--outlined fieldset {
    border-color: #e3e8ef !important;
    transition: border-color 0.2s, box-shadow 0.2s;
}

::v-deep .v-text-field--outlined:hover fieldset {
    border-color: #c7d2e0 !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--c-navy) !important;
    border-width: 2px !important;
    box-shadow: 0 0 0 4px rgba(13, 44, 109, 0.06);
}

::v-deep .v-text-field--outlined .v-label {
    font-family: inherit;
}

::v-deep .v-text-field--outlined .v-input__prepend-inner {
    margin-top: 9px !important;
}

::v-deep .v-text-field--outlined .v-input__prepend-inner .v-icon {
    color: var(--c-text-mute) !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused .v-input__prepend-inner .v-icon {
    color: var(--c-navy) !important;
}

/* ─── FOOTER ─── */
.cs-dlg-foot {
    background: #ffffff;
    border-top: 1px solid var(--c-border-soft);
}

.cs-dlg-progress {
    display: block;
}

.cs-dlg-foot__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 22px;
}

.cs-dlg-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 22px;
    border-radius: 10px;
    border: none;
    font-family: inherit;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.cs-dlg-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.cs-dlg-btn--ghost {
    background: transparent;
    color: var(--c-text-soft);
    border: 1px solid #e3e8ef;
}

.cs-dlg-btn--ghost:hover:not(:disabled) {
    background: #f8fafc;
    color: var(--c-text);
}

.cs-dlg-btn--primary {
    background: linear-gradient(135deg, var(--c-navy) 0%, #142f78 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(13, 44, 109, 0.45);
}

.cs-dlg-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.08);
}

@media (max-width: 600px) {
    .cs-dlg-head {
        padding: 14px 18px;
    }

    .cs-dlg-title {
        font-size: 1rem;
    }

    .cs-dlg-body {
        padding: 18px 18px 4px !important;
    }

    .cs-dlg-section {
        padding: 14px 14px 4px;
    }

    .cs-dlg-foot__actions {
        padding: 12px 16px;
    }

    .cs-dlg-btn {
        padding: 9px 16px;
        font-size: 0.85rem;
    }
}
</style>